import React, { Component } from "react";
import { Nav, NavItem } from 'react-bootstrap';
import { Route, Switch } from 'react-router';
import { Link } from "react-router-dom";
import AuthContext from '../auth-context';
import TrialCoachingSessionsService from '../utils/TrialCoachingSessionsService';
import UsersService from '../utils/UsersService';
import TCSList from "./TCSList";

class TCSListView extends Component {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    const authStore = this.context
    this.isRestrictedCoach = authStore.hasRole('coach_restricted')
    const { view } = props.match.params
    this.state = {
      coaches: [],
      stats: {},
      activeView: view
    };
  }

  componentDidMount() {
    this.setState({ loadingInProgress: true });
    this.fetchCoaches();
    this.fetchStats()
  }

  fetchCoaches() {
    UsersService.allUsers().then(data => {
      this.setState({ coaches: data.filter((c) => c.roles.includes('tcs_coach')).sort((a, b) => (a.name > b.name) ? 1 : -1), loadingInProgress: false })
    });
  }

  fetchStats() {
    const authStore = this.context
    TrialCoachingSessionsService.stats(this.isRestrictedCoach ? authStore.profile.email : '').then(data => {
      this.setState({ stats: data });
    });
  }

  handleSelect = (eventKey) => {
    this.setState({ activeView: eventKey });
  }

  render() {
    const { stats } = this.state;
    const isCoachRestricted = this.context.hasRole('coach_restricted');
    const isAdmin = this.context.hasRole('admin');
    const hideNumbers = !(isCoachRestricted && !isAdmin);

    return (
      <div>
        <h3 className="first-title">Trial Coaching Sessions</h3>

        <div className="row">
          <div className="col-sm-12">
            <Nav bsStyle="tabs" activeKey={this.state.activeView}
              onSelect={this.handleSelect.bind(this)}>
              <NavItem eventKey='today' componentClass={Link} to="/m1/tcs/list/today" href="/m1/tcs/list/today">Today <span>{hideNumbers && `(${stats.today || 0})`}</span></NavItem>
              <NavItem eventKey='week_ahead' componentClass={Link} to="/m1/tcs/list/week_ahead" href="/m1/tcs/list/week_ahead">Week Ahead <span>{hideNumbers && `(${stats.week_ahead || 0})`}</span></NavItem>
              <NavItem eventKey='month_ahead' componentClass={Link} to="/m1/tcs/list/month_ahead" href="/m1/tcs/list/month_ahead">Month Ahead <span>{hideNumbers && `(${stats.month_ahead || 0})`}</span></NavItem>
              <NavItem eventKey='overdue' componentClass={Link} to="/m1/tcs/list/overdue" href="/m1/tcs/list/overdue"><span className={stats.overdue && stats.overdue > 0 && 'text-danger'}> Sale Overdue ({stats.overdue || 0})</span></NavItem>
              <NavItem eventKey='need_confirmation' componentClass={Link} to="/m1/tcs/list/need_confirmation" href="/m1/tcs/list/need_confirmation"><span className={stats.need_confirmation && stats.need_confirmation > 0 && 'text-danger'}> Needs Confirmation ({stats.need_confirmation || 0})</span></NavItem>
              <NavItem eventKey='need_tech_call' componentClass={Link} to="/m1/tcs/list/need_tech_call" href="/m1/tcs/list/need_tech_call"><span className={stats.need_tech_call && stats.need_tech_call > 0 && 'text-danger'}> Needs Tech Call ({stats.need_tech_call || 0})</span></NavItem>
              <NavItem eventKey='on_hold' componentClass={Link} to="/m1/tcs/list/on_hold" href="/m1/tcs/list/on_hold"><span className={stats.on_hold && stats.on_hold > 0 && 'text-warning'}>On Hold ({stats.on_hold || 0})</span></NavItem>
              <NavItem eventKey='unassigned' componentClass={Link} to="/m1/tcs/list/unassigned" href="/m1/tcs/list/unassigned"><span className={stats.unassigned && stats.unassigned > 0 && 'text-danger'}>Current Unassigned ({stats.unassigned || 0})</span></NavItem>
              <NavItem eventKey='booked' componentClass={Link} to="/m1/tcs/list/booked" href="/m1/tcs/list/booked">All</NavItem>
            </Nav>
            <div className="tab-content">
              <Switch>
                <Route path={'/m1/tcs/list/:view'} render={(props) => <TCSList coaches={this.state.coaches} view={this.state.activeView} {...props} />} />
              </Switch>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TCSListView